"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_loan_application = exports.create_loan_application = void 0;
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("../../../firebase");
var store_1 = require("../../../store");
var functions_1 = require("../../../constants/functions");
var firebase_collections_1 = require("../../../constants/firebase_collections");
var lead_source_1 = require("../../../constants/lead_source");
var platform_1 = require("../../../constants/platform");
function create_loan_application(request) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __awaiter(this, void 0, void 0, function () {
        var state, userState, userDocRef, providerRef, _k, branchRef, _l, loansCollectionRef, newLoanDocRef, newLoanDocSnapshot, loanData, error_1;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    _m.trys.push([0, 11, , 12]);
                    state = store_1.redux_store.getState();
                    userState = state.userState;
                    // CRITICAL: Validate provider and branch - reject empty strings
                    if (request.provider && request.provider.trim() === "") {
                        console.error("CRITICAL: Attempted to create loan with empty provider string");
                        return [2 /*return*/, { success: false, message: "Provider cannot be empty", content: null }];
                    }
                    if (request.branch && request.branch.trim() === "") {
                        console.error("CRITICAL: Attempted to create loan with empty branch string");
                        return [2 /*return*/, { success: false, message: "Branch cannot be empty", content: null }];
                    }
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.USERS, "".concat(userState.user.uid))];
                case 1:
                    userDocRef = _m.sent();
                    if (!request.provider) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.PROVIDERS, request.provider)];
                case 2:
                    _k = _m.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _k = null;
                    _m.label = 4;
                case 4:
                    providerRef = _k;
                    if (!request.branch) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.BRANCHES, request.branch)];
                case 5:
                    _l = _m.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _l = null;
                    _m.label = 7;
                case 7:
                    branchRef = _l;
                    return [4 /*yield*/, (0, firestore_1.collection)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.LOAN_APPLICATIONS)];
                case 8:
                    loansCollectionRef = _m.sent();
                    return [4 /*yield*/, (0, firestore_1.addDoc)(loansCollectionRef, __assign(__assign(__assign({ amount: parseFloat((_a = request === null || request === void 0 ? void 0 : request.amount) !== null && _a !== void 0 ? _a : "0") }, (providerRef && { provider: providerRef })), (branchRef && { branch: branchRef })), { basket_id: (_b = request === null || request === void 0 ? void 0 : request.basket_id) !== null && _b !== void 0 ? _b : "", date_started: new Date(), code: Math.random().toString(36).substring(2, 10).toUpperCase(), user: userDocRef, status: (_c = request.status) !== null && _c !== void 0 ? _c : "DRAFT", docs_complete: false, employment_complete: false, family_complete: false, financial_complete: false, friend_complete: false, is_product: (_d = request.is_product) !== null && _d !== void 0 ? _d : false, paypoint_complete: false, personal_complete: false, sumsub_complete: false, agree_terms: (_e = request.agree_terms) !== null && _e !== void 0 ? _e : false, authoriseBank_complete: false, authoriseSalary_complete: false, bankDetails_complete: false, term: (_f = request.term) !== null && _f !== void 0 ? _f : "12 Months", order_id: (_g = request === null || request === void 0 ? void 0 : request.order_id) !== null && _g !== void 0 ? _g : "", order_number: (_h = request === null || request === void 0 ? void 0 : request.order_number) !== null && _h !== void 0 ? _h : "", products: (_j = request === null || request === void 0 ? void 0 : request.products) !== null && _j !== void 0 ? _j : null, sources: {
                                initiated: "web",
                            }, lead_source: {
                                initiated: lead_source_1.LEAD_SOURCE,
                            }, country: platform_1.PLATFORM_COUNTRY }))];
                case 9:
                    newLoanDocRef = _m.sent();
                    return [4 /*yield*/, (0, firestore_1.getDoc)(newLoanDocRef)];
                case 10:
                    newLoanDocSnapshot = _m.sent();
                    if (newLoanDocSnapshot.exists()) {
                        loanData = newLoanDocSnapshot.data();
                        return [2 /*return*/, { success: true, message: "Loan Application Started", content: __assign({ uid: newLoanDocSnapshot === null || newLoanDocSnapshot === void 0 ? void 0 : newLoanDocSnapshot.id }, loanData) }];
                    }
                    else {
                        return [2 /*return*/, { success: false, message: "Failed to create loan application", content: null }];
                    }
                    return [3 /*break*/, 12];
                case 11:
                    error_1 = _m.sent();
                    return [2 /*return*/, { success: false, message: "An error occurred", content: null }];
                case 12: return [2 /*return*/];
            }
        });
    });
}
exports.create_loan_application = create_loan_application;
function update_loan_application(request) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var loanDocRef, updateData, _d, _e, _f, _g, docSnapshot, existing, currentSources, currentLeadSource, _h, _j, _k, loanDocSnapshot, loanData, error_2;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    _l.trys.push([0, 14, , 15]);
                    // CRITICAL: Validate provider and branch - reject empty strings
                    if (request.provider && request.provider.trim() === "") {
                        console.error("CRITICAL: Attempted to update loan with empty provider string");
                        return [2 /*return*/, { success: false, message: "Provider cannot be empty", content: null }];
                    }
                    if (request.branch && request.branch.trim() === "") {
                        console.error("CRITICAL: Attempted to update loan with empty branch string");
                        return [2 /*return*/, { success: false, message: "Branch cannot be empty", content: null }];
                    }
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.LOAN_APPLICATIONS, "".concat(request.uid))];
                case 1:
                    loanDocRef = _l.sent();
                    //remove null objects from reques
                    request = (0, functions_1.removeUndefinedProperties)(request);
                    updateData = {};
                    if (request.docs_complete)
                        updateData["docs_complete"] = request.docs_complete;
                    if (request.employment_complete)
                        updateData["employment_complete"] = request.employment_complete;
                    if (request.family_complete)
                        updateData["family_complete"] = request.family_complete;
                    if (request.financial_complete)
                        updateData["financial_complete"] = request.financial_complete;
                    if (request.friend_complete)
                        updateData["friend_complete"] = request.friend_complete;
                    if (request.bankDetails_complete)
                        updateData["bankDetails_complete"] = request.bankDetails_complete;
                    if (request.paypoint_complete)
                        updateData["paypoint_complete"] = request.paypoint_complete;
                    if (request.sumsub_complete)
                        updateData["sumsub_complete"] = request.sumsub_complete;
                    if (request.personal_complete)
                        updateData["personal_complete"] = request.personal_complete;
                    if (request.agree_terms)
                        updateData["agree_terms"] = request.agree_terms;
                    if (request.authoriseBank_complete)
                        updateData["authoriseBank_complete"] = request.authoriseBank_complete;
                    if (request.authoriseSalary_complete)
                        updateData["authoriseSalary_complete"] = request.authoriseSalary_complete;
                    if (request.spouse)
                        updateData["spouse"] = request.spouse;
                    if (request.home_address)
                        updateData["home_address"] = request.home_address;
                    if (request.postal_address)
                        updateData["postal_address"] = request.postal_address;
                    if (request.family_member)
                        updateData["family_member"] = request.family_member;
                    if (request.friend)
                        updateData["friend"] = request.friend;
                    if (request.employment_details)
                        updateData["employment_details"] = request.employment_details;
                    if (request.salary_bank_details)
                        updateData["salary_bank_details"] = request.salary_bank_details;
                    if (request.financial_detail)
                        updateData["financial_detail"] = request.financial_detail;
                    if (request.latest_payslip)
                        updateData["latest_payslip"] = request.latest_payslip;
                    if (request.bank_statements)
                        updateData["bank_statements"] = request.bank_statements;
                    if (request.copy_of_id)
                        updateData["copy_of_id"] = request.copy_of_id;
                    if (request.force_number)
                        updateData["force_number"] = request.force_number;
                    if (request.authoriseSalary_complete)
                        updateData["authoriseSalary_complete"] = request.authoriseSalary_complete;
                    if (request.bank_debit_signature)
                        updateData["bank_debit_signature"] = request.bank_debit_signature;
                    if (request.salary_deduction_signature)
                        updateData["salary_deduction_signature"] = request.salary_deduction_signature;
                    if (request.status)
                        updateData["status"] = request.status;
                    if (request.term)
                        updateData["term"] = request.term;
                    if (request.paypoint_details)
                        updateData["paypoint_details"] = request.paypoint_details;
                    if (!request.provider) return [3 /*break*/, 3];
                    _d = updateData;
                    _e = "provider";
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.PROVIDERS, request.provider)];
                case 2:
                    _d[_e] = _l.sent();
                    _l.label = 3;
                case 3:
                    if (!request.branch) return [3 /*break*/, 5];
                    _f = updateData;
                    _g = "branch";
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.BRANCHES, request.branch)];
                case 4:
                    _f[_g] = _l.sent();
                    _l.label = 5;
                case 5:
                    if (request.order_id)
                        updateData["order_id"] = request.order_id;
                    if (request.order_number)
                        updateData["order_number"] = request.order_number;
                    if (request.country)
                        updateData["country"] = request.country;
                    if (request.date_completed)
                        updateData["date_completed"] = request.date_completed;
                    if (request.products !== undefined)
                        updateData["products"] = request.products;
                    if (request.basket_id !== undefined)
                        updateData["basket_id"] = request.basket_id;
                    if (request.amount !== undefined)
                        updateData["amount"] = Number(request.amount);
                    if (request.is_product !== undefined)
                        updateData["is_product"] = request.is_product;
                    if (!(request.status === "AWAIT")) return [3 /*break*/, 7];
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 6:
                    docSnapshot = _l.sent();
                    existing = docSnapshot.exists() ? docSnapshot.data() : {};
                    currentSources = (_a = existing.sources) !== null && _a !== void 0 ? _a : {};
                    currentLeadSource = (_b = existing.lead_source) !== null && _b !== void 0 ? _b : {};
                    updateData.sources = __assign(__assign({}, currentSources), { updated: "web" });
                    updateData.lead_source = __assign(__assign({}, currentLeadSource), { updated: lead_source_1.LEAD_SOURCE });
                    _l.label = 7;
                case 7:
                    if (!request.salesAgreement) return [3 /*break*/, 11];
                    _h = updateData;
                    _j = "salesAgreement";
                    if (!request.salesAgreement) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, firestore_1.doc)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.DEVICE_SALES_AGREEMENTS, (_c = request.salesAgreement) !== null && _c !== void 0 ? _c : "")];
                case 8:
                    _k = _l.sent();
                    return [3 /*break*/, 10];
                case 9:
                    _k = "";
                    _l.label = 10;
                case 10:
                    _h[_j] = _k;
                    _l.label = 11;
                case 11: 
                // Update Firebase Doc
                return [4 /*yield*/, (0, firestore_1.updateDoc)(loanDocRef, updateData)];
                case 12:
                    // Update Firebase Doc
                    _l.sent();
                    return [4 /*yield*/, (0, firestore_1.getDoc)(loanDocRef)];
                case 13:
                    loanDocSnapshot = _l.sent();
                    if (loanDocSnapshot.exists()) {
                        loanData = loanDocSnapshot.data();
                        return [2 /*return*/, { success: true, message: "Loan Application Updated", content: __assign({ uid: loanDocSnapshot === null || loanDocSnapshot === void 0 ? void 0 : loanDocSnapshot.id }, loanData) }];
                    }
                    else {
                        return [2 /*return*/, { success: false, message: "Failed to update loan application", content: null }];
                    }
                    return [3 /*break*/, 15];
                case 14:
                    error_2 = _l.sent();
                    return [2 /*return*/, { success: false, message: "An error occurred", content: null }];
                case 15: return [2 /*return*/];
            }
        });
    });
}
exports.update_loan_application = update_loan_application;
